import { render, staticRenderFns } from "./formEditBase.vue?vue&type=template&id=fb1ba9f6"
import script from "./formEditBase.vue?vue&type=script&lang=js"
export * from "./formEditBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb1ba9f6')) {
      api.createRecord('fb1ba9f6', component.options)
    } else {
      api.reload('fb1ba9f6', component.options)
    }
    module.hot.accept("./formEditBase.vue?vue&type=template&id=fb1ba9f6", function () {
      api.rerender('fb1ba9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/base/components/form/formEditBase.vue"
export default component.exports